"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.boldMatchedText = void 0;
var _jsxRuntime = require("react/jsx-runtime");
const boldMatchedText = ({
  text,
  searchPhrase
}) => {
  if (!text) {
    return null;
  }
  if (!searchPhrase) {
    return text;
  }
  const escapedSearchPhrase = searchPhrase.replaceAll(/[$()*+.?[\\\]^{|}]/g, '\\$&').trim();
  const regExpPattern = new RegExp(escapedSearchPhrase, 'igu');
  const splitText = text.split(regExpPattern);
  const matches = text.match(regExpPattern);
  if (!matches) {
    return text;
  }
  return splitText.map((el, index) => {
    if (index > matches.length) {
      return el;
    }
    return (/*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key -- there is nothing unique here and this array is not mutable
      (0, _jsxRuntime.jsxs)("span", {
        children: [el, /*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
          children: matches[index]
        })]
      }, `${el}-${text}-${index}`)
    );
  });
};
exports.boldMatchedText = boldMatchedText;